import React, { useEffect, useState } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  Container,
  Row,
  Col,
  Input,
  Button,
} from "reactstrap";
import { getApiDataService, postApiDataService } from "../../../services/apiServices";
import { SETTING, UPDATE_SETTING } from "../../../services/CONSTANTS";
import { toast } from "react-toastify";
import Header from "components/Headers/Header";

function PointPercent() {
  const [percent, setPercent] = useState("0");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getApiDataService(SETTING).then((res) => {
      setPercent(res.data.reward_point_percent ?? "");
    });
  }, []);

  const handleSave = () => {
    setLoading(true);
    postApiDataService(UPDATE_SETTING, {
      reward_point_percent: Number(percent),
    })
      .then(() => {
        toast.success("Point percent updated");
        setLoading(false);
      })
      .catch(() => {
        toast.error("Update failed");
        setLoading(false);
      });
  };

  return (
    <>
      <Header />
      <Container className="mt--7" fluid>
        <Row>
          <Col md="6">
            <Card className="shadow">
              <CardHeader>
                <h3 className="mb-0">Point Reward Percent</h3>
              </CardHeader>
              <CardBody>
                <Input
                  type="number"
                  min="0"
                  max="100"
                  className="font-mono"
                  aria-label="Point reward percent"
                  value={percent}
                  onChange={(e) => setPercent(e.target.value)}
                />
                <small className="text-muted">
                  Example: 5 = 5% reward
                </small>
                <div className="d-flex justify-content-end mt-3">
                <Button
                  color="primary"
                  className="mt-3"
                  disabled={loading}
                  onClick={handleSave}
                >
                  Save
                </Button>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default PointPercent;
